import { useLayoutEffect, useEffect } from 'react';

// https://medium.com/@alexandereardon/uselayouteffect-and-ssr-192986cdcf7a

/* istanbul ignore next */
var useIsomorphicLayoutEffect = /* istanbul ignore next */
typeof document !== 'undefined' /* istanbul ignore next */ ? useLayoutEffect /* istanbul ignore next */ : /* istanbul ignore next */
useEffect;

export { useIsomorphicLayoutEffect };
